import { useLocationState } from './useLocationState'

export default useLocationState
